import React from "react";
import LegalLayout, { H2, P, UL } from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" subtitle="Legal · 01" lastUpdated="February 2026">
      <P>
        These Terms of Service ("Terms") govern access to and use of the website, services and operational
        capabilities offered by CAMO ("CAMO", "we", "our", "us"). By accessing the site, becoming a Member,
        or requesting any operation, you ("Client", "Member", "you") agree to be bound by these Terms.
      </P>
      <P>If you do not agree, do not use the service.</P>

      <H2>1. Nature of Services</H2>
      <P>
        CAMO is a private digital operations firm providing growth, intelligence and protection services
        through a subscription-based model. CAMO is not a law firm, licensed investigator, financial
        advisor, or cybersecurity certifying body. Services are advisory and operational in nature and do
        not constitute legal, financial, medical or regulated professional advice.
      </P>

      <H2>2. Eligibility</H2>
      <UL>
        <li>You must be at least 18 years old to use the service.</li>
        <li>You must have legal authority to bind any organization on whose behalf you engage CAMO.</li>
        <li>CAMO reserves the right to refuse or terminate service to any party at its sole discretion.</li>
      </UL>

      <H2>3. Membership & Payments</H2>
      <P>
        Memberships are billed in advance on a monthly basis at the rates published on the Site (Basic,
        Professional, Executive). All payments are processed exclusively through PayPal. Prices are in Euros
        (€) and exclude any applicable VAT or transaction fees imposed by PayPal.
      </P>
      <UL>
        <li>Subscriptions renew automatically until cancelled per Section 8.</li>
        <li>Executive tier is application-based and may be subject to additional onboarding requirements.</li>
        <li>On-demand operations are priced separately according to scope.</li>
      </UL>

      <H2>4. Acceptable Use</H2>
      <P>You agree not to engage CAMO for, request, or use deliverables in connection with:</P>
      <UL>
        <li>Activities prohibited by law in any applicable jurisdiction.</li>
        <li>Harassment, stalking, doxxing, or targeting of private individuals.</li>
        <li>Unauthorized access, hacking, or circumvention of security systems.</li>
        <li>Defamation, fraud, market manipulation or other tortious conduct.</li>
        <li>Surveillance of, or operations against, public officials, journalists, minors, or protected
          classes in violation of applicable law.</li>
      </UL>
      <P>
        CAMO operates under open-source intelligence (OSINT) principles and applicable privacy law.
        Any request found to violate this section will be refused without refund.
      </P>

      <H2>5. Confidentiality</H2>
      <P>
        Both parties agree to maintain the confidentiality of any non-public information exchanged in the
        course of an engagement. CAMO does not disclose Client identity or engagement details to third
        parties except as required by law.
      </P>

      <H2>6. Intellectual Property</H2>
      <P>
        All deliverables produced specifically for a Client remain the property of CAMO until full payment
        is received, at which point a non-exclusive, non-transferable license is granted to the Client for
        internal use. CAMO retains all rights to underlying frameworks, methodologies and pre-existing IP.
      </P>

      <H2>7. Disclaimers & Limitation of Liability</H2>
      <P>
        SERVICES ARE PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
        LIMITED TO MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR ACHIEVEMENT OF ANY SPECIFIC
        OUTCOME. To the maximum extent permitted by law, CAMO's aggregate liability arising out of or
        relating to the Terms shall not exceed the total fees paid by Client in the three (3) months
        preceding the claim.
      </P>
      <P>
        CAMO is not liable for indirect, consequential, incidental, special, punitive or exemplary damages,
        including loss of profits, revenue, data, goodwill or reputation.
      </P>

      <H2>8. Cancellation</H2>
      <P>
        Members may cancel a subscription at any time by contacting CAMO via Discord (@felopic) or
        Instagram (@camointelligence). Cancellations take effect at the end of the current billing cycle
        and no pro-rata refunds are issued. See the Refund Policy for further detail.
      </P>

      <H2>9. Indemnification</H2>
      <P>
        You agree to indemnify and hold harmless CAMO, its operators, contractors and affiliates from any
        claim, loss, liability, damage or expense (including reasonable legal fees) arising from your
        breach of these Terms or misuse of any deliverable.
      </P>

      <H2>10. Governing Law & Disputes</H2>
      <P>
        These Terms are governed by the laws of Italy, without regard to conflict-of-law principles. Any
        dispute shall be submitted to the exclusive jurisdiction of the competent courts of Italy. Where
        mandatory consumer protection rules of the Client's country of residence apply, those rules prevail.
      </P>

      <H2>11. Modifications</H2>
      <P>
        CAMO may amend these Terms at any time by posting the revised version on the Site. Continued use
        after publication constitutes acceptance of the amended Terms.
      </P>

      <H2>12. Contact</H2>
      <P>
        For all legal notices: Discord @felopic · Instagram @camointelligence.
      </P>
    </LegalLayout>
  );
}
